import type { Course } from '@/types/course';
import CourseCard from '@/components/base/CourseCard';
import SectionHeading from '@/components/base/SectionHeading';

interface CourseGridSectionProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  courses: Course[];
  viewAllTo?: string;
}

export default function CourseGridSection({
  eyebrow,
  title,
  desc,
  courses,
  viewAllTo,
}: CourseGridSectionProps) {
  return (
    <div>
      <SectionHeading
        eyebrow={eyebrow}
        title={title}
        desc={desc}
        viewAllTo={viewAllTo}
        viewAllLabel="查看更多"
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
        {courses.map((course) => (
          <CourseCard key={course.id} course={course} />
        ))}
      </div>
    </div>
  );
}